// extracted by mini-css-extract-plugin
module.exports = {"LandingMenuItem":"LandingMenuItem__LandingMenuItem___3jkzG","MenuItemWraaper":"LandingMenuItem__MenuItemWraaper___1XczC"};